import { useState, useEffect } from 'react';
import { css } from '@linaria/core';
import { getExistingFilterData } from '../../utils';
import classNames from 'classnames';
import { trackFilterSelection } from '../../utils/dataLayer';
import { screenReaderOnly } from '../../utils/styles';

const wrapper = css`
  padding: 0 0 10px 0;

  @media (min-width: 1080px) {
    padding: 0 0 10px 0;
  }
`;

const switchContainer = css`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const label = css`
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
`;

const labelText = css`
  font-size: 16px;
`;

const labelTextActive = css`
  font-weight: 600;
`;

const switchToggle = css`
  position: relative;
  display: inline-block;
  width: 67px;
  height: 32px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;

const slider = css`
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #f2ede8;
  border-radius: 50px;
  border: solid 1px #1a1a1a;

  &:before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 2px;
    bottom: 2px;
    background-color: #1a1a1a;
    border-radius: 50%;
  }

  input:checked + & {
    background-color: #004258;

    &:before {
      transform: translateX(36px);
      background-color: #fff;
    }
  }

  input:focus + & {
    outline: 3px solid #ffdd00;
  }
`;

export default function ToggleSwitchFilter(props) {
  const [isOn, setIsOn] = useState(false);

  useEffect(() => {
    const existingValue = getExistingFilterData(props.fieldId, props.filters);

    if (!existingValue) {
      setIsOn(false);
    } else if (existingValue.includes('true')) {
      setIsOn(true);
    } else if (existingValue.includes('false')) {
      props.removeFilter(props.fieldId);
      setIsOn(false);
    }
  }, [props.filters, props.removeFilter]);

  const handleToggle = () => {
    const newState = !isOn;
    setIsOn(newState);

    if (newState) {
      props.setFilter(props.fieldId, 'true');
      trackFilterSelection(props.fieldId, props.label);
    } else {
      props.removeFilter(props.fieldId);
    }
  };

  return (
    <div className={wrapper}>
      <span className={label} id={`${props.id}-label`}>
        {props.label}
      </span>

      <div className={switchContainer}>
        <span
          aria-hidden="true"
          className={classNames(labelText, !isOn && labelTextActive)}
        >
          Off
        </span>

        <label className={switchToggle}>
          <input
            aria-checked={isOn}
            checked={isOn}
            id={props.id}
            onChange={handleToggle}
            role="switch"
            type="checkbox"
          />
          <span className={slider}></span>
          <span className={screenReaderOnly}>{props.label}</span>
        </label>

        <span
          aria-hidden="true"
          className={classNames(labelText, isOn && labelTextActive)}
        >
          On
        </span>
      </div>
    </div>
  );
}
